import {TextField} from "@mui/material";
import React from "react";
import {makeStyles} from "@mui/styles";
import _ from 'lodash';

export default function BasicTextField({input, variant = "outlined", label, id, name, handleChange, meta: { touched, error }}) {
    const classes = useStyles();
    const hasError = touched && !_.isEmpty(error);

    return(
        <div>
            <TextField className={ hasError ? classes.textFieldError : classes.textField }
                       InputProps={{ classes: { root: classes.textField } }}
                       id={id}
                       name={name}
                       label={label}
                       variant={variant}
                       onChange={handleChange}
                       {...input}
                       error={ hasError } />
        </div>

    )
}

const useStyles = makeStyles({
    textField: {
        width: '100%',
        fontSize: '16px !important',
        backgroundColor: 'unset !important',
        fontFamily: 'FustatRegular !important',
        color: '#115d82',
        [`& fieldset`]: {
            border: '1px solid #115d82',
            borderRadius: '10px',
        },
        [`& label`]: {
            fontSize: '16px',
            fontFamily: 'FustatRegular !important',
        },

        '& label.Mui-focused': {
            color: '#115d82',
            fontFamily: 'FustatRegular !important',
        },

        '& .MuiInput-underline:after': {
            borderBottomColor: '#115d82',
        },
        '& .MuiOutlinedInput-root': {
            '& fieldset': {
                borderColor: '#115d82',
            },
            '&:hover fieldset': {
                borderColor: '#1d465c',
            },
            '&.Mui-focused fieldset': {
                borderColor: '#1d465c',
            },
        },
        '& .MuiInputBase-input': {
            fontFamily: 'FustatRegular !important',
        }
    },

    textFieldError: {
        width: '100%',
        fontSize: '16px !important',
        fontFamily: 'FustatRegular !important',
        backgroundColor: 'unset !important',
        color: '#115d82',
        [`& fieldset`]: {
            border: '1px solid #EB5757',
            borderRadius: '10px',
        },
        [`& label`]: {
            fontSize: '16px',
            fontFamily: 'FustatRegular !important',
        },
        '& .MuiInputBase-input': {
            fontFamily: 'FustatRegular !important',
        }
    },
});